// extracted by mini-css-extract-plugin
export default {"tagCloud":"TagCloudChart_tagCloud__CsJhw","wrapper":"TagCloudChart_wrapper__DBlcK","title":"TagCloudChart_title__4oZoG"};